import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { AuthService } from './auth.service';

/**
 * Adjunta el token de sesión a las llamadas al API de SiLabVet y, ante un 401,
 * limpia la sesión y manda al login.
 */
export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const auth = inject(AuthService);
  const router = inject(Router);

  const esApiPropia = req.url.startsWith(environment.apiUrl);
  const token = auth.getToken();
  const request =
    esApiPropia && token
      ? req.clone({ setHeaders: { Authorization: `Bearer ${token}` } })
      : req;

  return next(request).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401 && esApiPropia) {
        auth.limpiarSesion();
        void router.navigate(['/login']);
      }
      return throwError(() => error);
    }),
  );
};
